import { guideTitles } from 'legacy/lut/components/widgets/public/partner360/ELT/models/PageTitles'
import { Header } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/header/Header'
import { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './GuideHeader.module.scss'

interface IProps {
  guideStep: number
}

export const GuideHeader = ({ guideStep }: IProps) => {
  const { title } = useMemo(() => {
    return guideTitles[guideStep]
  }, [guideStep])
  return (
    <Header>
      <div>
        <div className={styles.title}>
          <Translation text={title} />
        </div>
      </div>
    </Header>
  )
}
